import { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { SignUpForm7ways } from '@components/Block'

function SevenWaysHeader (props) {

    const [lgShow, setLgShow] = useState(false);

return (
    <>
    <div className="sevenWays__Header pt-5">
        <Container>
            <Row>
                <Col lg={6} md={12} sm={12}>
                <h3 className="text-center text-uppercase">Free Report Reveals</h3>
                <h1 className="text-center py-2">7 WAYS TO IMPROVE YOUR MEMORY, <br />FOCUS AND REDUCE MENTAL DECLINE</h1>
                <p className="pt-3 pb-2">Have you ever forgotten who you were calling after you dialed the phone? <br />Would a better memory help you at school or work?</p>
                <p>Get my free report and discover 7 simple, safe and natural ways to improve your brain's health, sharpen memory and prevent memory loss.</p>
                <h3 className="text-center">DOWNLOAD THE FREE REPORT</h3>
				<Button variant="default px-5 py-2 mt-4 text-left" onClick={() => setLgShow(true)}>DOWNLOAD NOW</Button>
                </Col>
            </Row>
        </Container>
    </div>
    <SignUpForm7ways show={lgShow} onHide={() => setLgShow(false)} global={props.global}/>
    <style jsx global>{`
        .sevenWays__Header .form-group{
            max-width: 50%;
        }
        .btn{
            font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
            background: #FFB700;
            color: #034683;
            box-shadow: 0px 5px 0px #bf8a01;
            font-size: 2.2rem;
            font-weight: 500;
        }
        .btn:hover{    
            background: #FFCC46;
            box-shadow: 0px 5px 0px #FFB700;
            color: #034683;
            border: 1px solid #034683;
        }

        @media (max-width: 1199px) {
            .sevenWays__Header .form-group{
                max-width: 85%;
            }

        }

        @media (max-width: 380px) {
            .btn{
                font-size:1.5rem;
            }

        }
        `}
    </style>
    <style jsx>{`
            .sevenWays__Header{
                background: url(../images/7ways/bg-index-header01.jpg) no-repeat right -300px;
                border-bottom: 10px solid #46D9BD;
                padding: 0px 0px 35px;
                color: #FFF;
            }
            h1{
                font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                background: #47bda8;
                font-weight: 500;
            }
            p{
                font-size:0.9rem;
            }

            @media (max-width: 1199px) {
                .sevenWays__Header--recaptcha{
                    padding-left: 65px!important;
                }

            }

            @media (max-width: 480px) {
                .sevenWays__Header{
                    background: url(../images/7ways/bg-index-header01.jpg) no-repeat right 0px;
                }
                h1{
                    font-size: 1.5rem;
                }

            }

            @media (max-width: 380px) {
                h3{
                    font-size: 1rem;
                }

            }
            .google-captcha > div > div > div > div{
                margin: 1rem auto;
            }
            .error_chk {
            border: 1px solid red !important;
            }
            `}
        </style>
    </>
);
}
export default SevenWaysHeader;